import { Seasons } from './constants.js';

export const seasonProfiles = {
  [Seasons.SPRING]: {
    id: Seasons.SPRING,
    label: '春 · 樱花',
    trunkColor: 0x5d3f2e,
    ambientColor: 0xfff0f8,
    fogColor: 0xfce5f3,
    elementType: 'blossom',
    elementCount: 980,
    scaleMin: 0.16,
    scaleMax: 0.29,
    driftStrength: 0.34,
    colors: [0xffbfd8, 0xffd9ea, 0xf8f5ff],
    background: 'radial-gradient(circle at 18% 16%, #ffe8f5 0%, #ffcde5 28%, #8bc5b3 68%, #193249 100%)'
  },
  [Seasons.SUMMER]: {
    id: Seasons.SUMMER,
    label: '夏 · 茂盛',
    trunkColor: 0x4b3526,
    ambientColor: 0xe8ffe6,
    fogColor: 0xb0dbbb,
    elementType: 'leaf',
    elementCount: 1180,
    scaleMin: 0.15,
    scaleMax: 0.31,
    driftStrength: 0.18,
    colors: [0x2d7d46, 0x48a95f, 0x5fc978, 0x1d5f31],
    background: 'radial-gradient(circle at 22% 14%, #b5f0c9 0%, #66c18d 35%, #2c6f5d 66%, #123141 100%)'
  },
  [Seasons.AUTUMN]: {
    id: Seasons.AUTUMN,
    label: '秋 · 落叶',
    trunkColor: 0x5a3820,
    ambientColor: 0xfff5d9,
    fogColor: 0xf2cf9d,
    elementType: 'autumnLeaf',
    elementCount: 920,
    scaleMin: 0.16,
    scaleMax: 0.33,
    driftStrength: 0.44,
    colors: [0xffb44d, 0xf08232, 0xe2582b, 0xf7d66f],
    background: 'radial-gradient(circle at 12% 12%, #ffe7bb 0%, #f3bf7d 30%, #9c5c39 66%, #232038 100%)'
  },
  [Seasons.WINTER]: {
    id: Seasons.WINTER,
    label: '冬 · 雪白',
    trunkColor: 0x4a4f63,
    ambientColor: 0xe6f0ff,
    fogColor: 0xd7e6ff,
    elementType: 'snowClump',
    elementCount: 860,
    scaleMin: 0.17,
    scaleMax: 0.36,
    driftStrength: 0.5,
    snowfallCount: 260,
    colors: [0xf8fbff, 0xdfeeff, 0xc6dcff, 0xffffff],
    background: 'radial-gradient(circle at 18% 16%, #f4fbff 0%, #d9e8ff 32%, #6587b3 66%, #132136 100%)'
  }
};

export function getSeasonProfile(seasonId) {
  return seasonProfiles[seasonId] ?? seasonProfiles[Seasons.SPRING];
}
